var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "news" },
    [
      _c("loading", { attrs: { loaded: _vm.isLoaded } }, [
        _c("div", { key: "content" }, [
          _c("div", { staticClass: "h2 notice-title" }, [
            _vm._v(_vm._s(_vm.$t("newsPage.pageTitle"))),
          ]),
          _c("div", { staticClass: "category-tabs" }, [
            _c("div", { staticClass: "tab-label" }, [
              _vm._v(_vm._s(_vm.$t("newsPage.categoryLabel"))),
            ]),
            _c(
              "div",
              { staticClass: "tabs-container" },
              _vm._l(_vm.categories, function (category) {
                return _c(
                  "div",
                  {
                    key: category.value,
                    staticClass: "tab-item",
                    class: { active: _vm.selectedCategory === category.value },
                    on: {
                      click: function ($event) {
                        return _vm.onCategoryChange(category.value)
                      },
                    },
                  },
                  [_vm._v(" " + _vm._s(category.label) + " ")]
                )
              }),
              0
            ),
          ]),
          _vm.news.length === 0
            ? _c("div", { staticClass: "empty-message" }, [
                _vm._v(_vm._s(_vm.$t("newsPage.emptyMessage"))),
              ])
            : _c(
                "div",
                { staticClass: "accbox" },
                _vm._l(_vm.news, function (newsItem) {
                  return _c(
                    "div",
                    { key: newsItem.id, staticClass: "news-item" },
                    [
                      _c("input", {
                        staticClass: "cssacc",
                        attrs: { type: "checkbox", id: newsItem.id },
                      }),
                      _c(
                        "label",
                        {
                          staticClass: "news-header",
                          attrs: { for: newsItem.id },
                        },
                        [
                          _vm.isNewItem(newsItem.publishedAt)
                            ? _c("div", { staticClass: "news-badge" }, [
                                _vm._v("NEW"),
                              ])
                            : _vm._e(),
                          _c("div", { staticClass: "news-meta" }, [
                            _c("span", { staticClass: "news-date" }, [
                              _vm._v(
                                _vm._s(_vm.formatDate(newsItem.publishedAt))
                              ),
                            ]),
                            _c("span", { staticClass: "news-category" }, [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.getCategoryLabel(newsItem)) +
                                  " "
                              ),
                            ]),
                          ]),
                          _c("div", { staticClass: "news-title" }, [
                            _vm._v(_vm._s(newsItem.title)),
                          ]),
                        ]
                      ),
                      _c("div", { staticClass: "accshow" }, [
                        _c("div", {
                          staticClass: "news-content",
                          domProps: { innerHTML: _vm._s(newsItem.text) },
                        }),
                      ]),
                    ]
                  )
                }),
                0
              ),
          _vm.news.length > 0
            ? _c(
                "div",
                { staticClass: "pager" },
                [
                  _c("div", { staticClass: "pager-context" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t("newsPage.pagerContext", {
                            start: _vm.currentPage * _vm.limit - _vm.limit + 1,
                            end: Math.min(
                              _vm.currentPage * _vm.limit,
                              _vm.totalCount
                            ),
                            total: _vm.totalCount,
                          })
                        ) +
                        " "
                    ),
                  ]),
                  _c("paginate", {
                    key: `paginate-${_vm.selectedCategory}`,
                    attrs: {
                      value: _vm.currentPage,
                      "page-count": _vm.getPageCount,
                      "click-handler": _vm.clickCallback,
                      "container-class": "pagination",
                      "page-class": "page-item",
                      "prev-class": "prev",
                      "next-class": "next",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ]),
      ]),
      _c("div", { staticClass: "space" }),
      _c("site-footer", { staticClass: "footer" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }